<div class="backoffice-container">
  <div class="header">
    <mat-tab-group (selectedTabChange)="tabChange($event)">
      <mat-tab label="CompaÃ±Ã­as"> </mat-tab>
      <mat-tab label="Coworkers"> </mat-tab>
      <mat-tab label="Coworkings"> </mat-tab>
      <mat-tab label="Usuarios"> </mat-tab>
      <mat-tab label="Reservas"> </mat-tab>
      <mat-tab label="Espacios"> </mat-tab>
    </mat-tab-group>
    <div class="container-logo" (click)="logOut()">
      <img [src]="getLogoutIcon" />
    </div>
  </div>
  <div class="container">
    <cowing-core-backoffice-companies
      *ngIf="getActiveTab === 'CompaÃ±Ã­as'"
    ></cowing-core-backoffice-companies>
    <cowing-core-backoffice-coworkers
      *ngIf="getActiveTab === 'Coworkers'"
    ></cowing-core-backoffice-coworkers>
    <cowing-core-backoffice-coworkings
      *ngIf="getActiveTab === 'Coworkings'"
    ></cowing-core-backoffice-coworkings>
    <cowing-core-backoffice-bookings
      *ngIf="getActiveTab === 'Reservas'"
    ></cowing-core-backoffice-bookings>
    <cowing-core-backoffice-users
      *ngIf="getActiveTab === 'Usuarios'"
    ></cowing-core-backoffice-users>
    <cowing-core-backoffice-spaces
      *ngIf="getActiveTab === 'Espacios'"
    ></cowing-core-backoffice-spaces>
  </div>
</div>
